module.exports = __webpack_public_path__ + "static/img/how-to-join-step-4.b76f39f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fifa2026/images/how-to-join-step-4.png
// module id = lrsI
// module chunks = 1